import StoryBoard from "../components/story-board/story-board.component"

const StoryBoardPage = () => {
  return (
    <StoryBoard />
  )
}

export default StoryBoardPage